<template>
  <div
    class="loadingButton"
    :class="{ disabled, loading, other_color }"
    @click="confirm"
  >
    <slot v-if="!loading"></slot>
    <van-loading
      v-if="loading"
      :style="{ color: other_color ? '#0c8027' : '#fff' }"
      size="0.6rem"
    ></van-loading>
  </div>
</template>
<script>
export default {
  name: 'commonBtn',
  props: {
    click: {
      type: Function,
      default () {
        return () => ''
      }
    },
    disabled: { type: Boolean, default: false },
    other_color: { type: Boolean, default: false }
  },
  data () {
    return {
      loading: false
    }
  },

  methods: {
    async confirm () {
      if (this.loading || this.disabled) return false
      this.loading = true
      try {
        await this.click()
      } catch (error) {
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped lang="less">
.loadingButton {
  padding: 16px 0;
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  border-radius: 30px;
  background: #0c8027;
}

.disabled {
  background: #bebebe;
}
.loading {
  padding: 0.36rem 0;
}
</style>
